export default __webpack_public_path__ + "static/media/ic-minus-rounded.4b62a247.svg";